"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var cids_1 = __importDefault(require("cids"));

var multihashing_async_1 = __importDefault(require("multihashing-async"));

var Hashing = /*#__PURE__*/function () {
  function Hashing() {
    _classCallCheck(this, Hashing);
  }

  _createClass(Hashing, null, [{
    key: "calculateHashes",

    /** Given a set of files, return a map with their hash */
    value: function () {
      var _calculateHashes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(files) {
        var _this = this;

        var entries;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                entries = Array.from(files).map( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _this.calculateHash(file);

                          case 2:
                            _context.t0 = _context.sent;
                            _context.t1 = file;
                            return _context.abrupt("return", {
                              hash: _context.t0,
                              file: _context.t1
                            });

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());
                return _context2.abrupt("return", Promise.all(entries));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function calculateHashes(_x) {
        return _calculateHashes.apply(this, arguments);
      }

      return calculateHashes;
    }()
    /** Return the given file's hash */

  }, {
    key: "calculateHash",
    value: function () {
      var _calculateHash = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(file) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.calculateBufferHash(file.content));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function calculateHash(_x3) {
        return _calculateHash.apply(this, arguments);
      }

      return calculateHash;
    }()
    /** Return the given buffer's hash */

  }, {
    key: "calculateBufferHash",
    value: function () {
      var _calculateBufferHash = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(buffer) {
        var hash;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return multihashing_async_1.default(buffer, "sha2-256");

              case 2:
                hash = _context4.sent;
                return _context4.abrupt("return", new cids_1.default(0, 'dag-pb', hash).toBaseEncodedString());

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function calculateBufferHash(_x4) {
        return _calculateBufferHash.apply(this, arguments);
      }

      return calculateBufferHash;
    }()
  }]);

  return Hashing;
}();

exports.Hashing = Hashing;